import { AP_PATHS } from '../adminPersonnelPaths';

const ACTION_TO_UI_TYPE = {
  create: null,
  update: 'edit',
  delete: 'delete',
  deactivate: 'warning',
  activate: 'success',
  import: 'success'
};

const ENTITY_TO_UI_TYPE = {
  member: 'user',
  company: 'company',
  user: 'user'
};

const ACTION_LABELS = {
  create: 'Création',
  update: 'Modification',
  delete: 'Suppression',
  activate: 'Activation',
  deactivate: 'Désactivation',
  import: 'Import'
};

const ENTITY_LABELS = {
  member: 'Adhérent',
  company: 'Société',
  user: 'Utilisateur'
};

export function deriveActivityUiType(row) {
  const fromAction = ACTION_TO_UI_TYPE[row.action];
  if (fromAction) return fromAction;
  return ENTITY_TO_UI_TYPE[row.entity_type] || 'system';
}

export function getActivityIcon(uiType) {
  const icons = {
    user: 'userPlus',
    company: 'building',
    system: 'settings',
    alert: 'alertCircle',
    edit: 'edit',
    delete: 'trash',
    success: 'checkCircle',
    warning: 'alertTriangle'
  };
  return icons[uiType] || 'infoCircle';
}

export function formatActorLabel(actor) {
  if (!actor) return null;
  if (typeof actor === 'string') return actor;
  const full = `${actor.first_name || ''} ${actor.last_name || ''}`.trim();
  return full || null;
}

export function formatActivityTime(timestamp) {
  if (!timestamp) return '—';
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '—';

  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return "À l'instant";
  if (diffMins < 60) return `Il y a ${diffMins} min`;
  if (diffHours < 24) return `Il y a ${diffHours} h`;
  if (diffDays < 7) return `Il y a ${diffDays} j`;

  return date.toLocaleString('fr-FR', {
    day: '2-digit',
    month: 'short',
    year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined,
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function mapActivityFromApi(row, idx = 0) {
  const uiType = deriveActivityUiType(row);
  return {
    id: row.id || `${row.kind}-${row.entity_id}-${idx}`,
    type: uiType,
    uiType,
    action: row.action,
    entityType: row.entity_type,
    entityId: row.entity_id,
    title: row.title,
    description: row.subtitle || (row.meta ? String(row.meta) : null),
    meta: row.meta,
    timestamp: row.occurred_at,
    user: formatActorLabel(row.actor),
    actionLabel: ACTION_LABELS[row.action] || row.action,
    entityLabel: ENTITY_LABELS[row.entity_type] || row.entity_type
  };
}

export function getActivityNavigateTarget(activity) {
  if (activity.entityType === 'company') return AP_PATHS.COMPANIES;
  if (activity.entityType === 'member') return AP_PATHS.MEMBERS;
  return null;
}
